<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <FormItem v-show="showTypeCtrl" :config="typeCtrl" :options="typeCtrl.options"
          :inputValue="formInline[typeCtrl.keyName]" @onChange="onChange" />
        <!-- <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item> -->
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="btn1" slot-scope="params">
        <el-button class="positionbtn" type="primary" @click="goGx(params.params)" size="mini">更新</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
export default {
  name: "VehicleHang",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'inspection',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/inspect` },
        { name: "车辆年检", path: `/vehicle/inspect` },
      ],
      showTypeCtrl: false,
      typeCtrl: {
        label: "种类",
        keyName: "inspection",
        placeholder: "请选择种类",
        type: "select",
        options: [
          { label: '全部', value: 3 },
          { label: '车头', value: 1 },
          { label: '挂车', value: 2 },
        ],
      },
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "最近一次年检时间",
          keyName: "last_inspection_at",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
        {
          label: "下次年检时间",
          keyName: "next_inspection_at",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号" },
        { keyName: "vtype", label: "车辆类型", className: 'pr30' },
        { keyName: "inspection_at", label: "最近一次年检时间" },
        { keyName: "cost", label: "最近一次年检费用" },
        { keyName: "institution", label: "年检机构" },
        { keyName: "next_inspection_at", label: "下次年检时间" },
        { keyName: "updated_at", label: "更新时间" },
        { keyName: "", label: "更新年检", slot: 'btn1' },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id, inspection }) => {
            this.$router.push(
              `/vehicle/inspectdetail?id=${id}&inspection=${inspection}`
            );
          },
        },
        {
          class: 'insurancebtn',
          img: require('@/assets/img/icon-jian.png'),
          unimg: require('@/assets/img/icon-jian-hover.png'),
          title: '年检记录',
          cb: ({ id, inspection }) => {
            this.$router.push(`/vehicle/inspecttables?id=${id}&inspection=${inspection}`);
          },
        },
      ],
      baseParams: ['inspection'],
    };
  },
  methods: {
    onReset() {
      console.log("onReset");
      const obj = {}
      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          // 重置为全部
          obj[v.keyName] = ''
        } else {
          obj[v.keyName] = undefined
        }
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = undefined
      })
      this.baseParams.map(v => {
        if (v == 'inspection') {
          // 重置为默认年份
          obj[v] = 3
        } else {
          obj[v] = this.formInline[v]
        }
      })
      // console.log(obj)
      this.formInline = obj;
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setState({
        key: 'formInline' + path,
        value: {},
      })
      // 回到首页
      this.page = 1;
      this.getList();
    },
    goGx({ id, license, vtype, inspection }) {
      // console.log(p)
      this.$router.push(`/vehicle/inspectview?mode=edit&license=${license}&vtype=${vtype}&id=${id}&inspection=${inspection}`);
    },
    onChange({ key, value }) {
      console.log(key, value)
      this.formInline[key] = value;
      console.log({ ...this.formInline });
      this.page = 1;
      this.getList()
    },
    setOptions({ inspection }) {
      // console.log(inspection)
      const path = this.$route.path
      if (inspection && inspection.includes('2')) {
        this.showTypeCtrl = true
        if (!(this.store && this.store['formInline' + path] && this.store['formInline' + path].inspection)) {
          this.formInline.inspection = 3

        }
      }
      this.getList()
    },
  },
  created() {
    this.formInline.inspection = 1
  },
  mounted() {
    this.getOptions()
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>